// extracted by mini-css-extract-plugin
module.exports = {"errorBoundary":"styles__errorBoundary___3nCLx","content":"styles__content___2VQiE","message":"styles__message___1JvsP","icon":"styles__icon___3Jafv"};